import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { appFirebase } from "../../../firebase/credenciales";
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
// import { getFirestore, collection, addDoc } from "firebase/firestore";


import Sorteo from "./sorteo";
import './sorteos.css';

const storage = getStorage(appFirebase);

const Sorteos = ({dataSorteos,socket, board}) => {
    const [dataSorteo, setDataSorteo] = useState([]);
    const [newSorteo, setNewSorteo] = useState(false);
    const [file, setFile] = useState(null);
    const [espera, setEspera] = useState(false);
    useEffect(()=>{
        dataSorteos ? setDataSorteo(dataSorteos) : setDataSorteo([])
    },[dataSorteos])
    useEffect(()=>{
        socket.on('ResponseSorteo',(Response)=>{
            Swal.fire(Response);
            setEspera(false);
            setNewSorteo(false);
    })
    },[socket])



    const [formData, setFormData] = useState({
        premio: '',
        valor: 0,
        puestos: 0,
        typeLot:''
    });

    

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleChangeNumer = (e) => {
        setFormData({ ...formData, [e.target.name]: parseInt(e.target.value) });
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };



const CrearSorteo = async (e) => {
    e.preventDefault();
    if (!file) {
        Swal.fire('Por favor, sube una imagen.');
        return;
    }

    try {
        // Crear la referencia de almacenamiento en Firebase Storage
        setEspera(true);
        const storageRef = ref(storage, `sorteos/${file.name}`);
        await uploadBytes(storageRef, file);
        const fileUrl = await getDownloadURL(storageRef);
        await setFormData({...formData, imagen: fileUrl})

        const dataSend = {
            formData,
            fileUrl
        }
        socket.emit('newSorteo',dataSend)
        // console.log(dataSend)
    } catch (error) {
        console.error('Error al crear el sorteo:', error);
        Swal.fire('Hubo un problema al crear el sorteo.');
        setEspera(false);
    }
};
    // Estado para controlar la visibilidad del div
    const [isVisibleDinero, setIsVisibleDinero] = useState(false);
    const [contDinero, setContDinero] = useState(0);
    const [isVisibleProducto, setIsVisibleProducto] = useState(false);
    const [contProducto, setContProducto] = useState(0);
    const [isVisibleExpress, setIsVisibleExpress] = useState(false);
    const [contExpress, setContExpress] = useState(0);
    const [isVisibleArchivado, setIsVisibleArchivado] = useState(false);
    const [contArchivado, setContArchivado] = useState(0);
    useEffect(()=>{
        setContDinero(dataSorteo.filter(sorteo => sorteo.typeLot === 'Dinero' && sorteo.estado !== 'archivado').length)
        setContProducto(dataSorteo.filter(sorteo => sorteo.typeLot === 'Producto' && sorteo.estado !== 'archivado').length)
        setContExpress(dataSorteo.filter(sorteo => sorteo.typeLot === 'Express' && sorteo.estado !== 'archivado').length)
        setContArchivado(dataSorteo.filter(sorteo => sorteo.estado === 'archivado').length)
    },[dataSorteo])
    // Función para alternar la visibilidad
    const toggleVisibility = (data) => {
        if(data === 'Dinero'){
            setIsVisibleDinero(!isVisibleDinero);
        }
        if(data === 'Producto'){
            setIsVisibleProducto(!isVisibleProducto)
        }
        if(data === 'Express'){
            setIsVisibleExpress(!isVisibleExpress)
        }
        if(data === 'archivado'){
            setIsVisibleArchivado(!isVisibleArchivado)
        }
        
    };


    return (
        <div className="sorteos-Admin">
            <div className="header-sorteos">
                <h2>Control de Sorteo</h2>
                <button className="btnform btn-agregar" onClick={() => setNewSorteo(!newSorteo)}>
                    {newSorteo ? 'Cancelar' : 'Crear Nuevo Sorteo'}
                </button>
            </div>
            
            {newSorteo && (
                <div className="newSorteo">
                    <form onSubmit={CrearSorteo}>
                        <input
                            type="text"
                            placeholder="Premio del sorteo"
                            className="cajatexto"
                            id="premio"
                            name="premio"
                            required
                            onChange={handleChange}
                        />
                        <input
                            type="number"
                            placeholder="Valor de cada puesto"
                            className="cajatexto"
                            id="Valor"
                            name="valor"
                            required
                            onChange={handleChangeNumer}
                        />
                        <input
                            list="sorteosList"
                            id="sorteos"
                            name="puestos"
                            placeholder="Cantidad de Puestos"
                            className="cajatexto"
                            required
                            onChange={handleChangeNumer}
                        />
                        <datalist id="sorteosList">
                            <option value="100" />
                            <option value="1000" />
                            <option value="10000" />
                        </datalist>
                        <input
                            list="typeLot"
                            id="typeLoto"
                            name="typeLot"
                            placeholder="Tipo de Sorteo"
                            className="cajatexto"
                            required
                            onChange={handleChange}
                        />
                        <datalist id="typeLot">
                            <option value="Dinero" />
                            <option value="Producto" />
                            <option value="Express" />
                        </datalist>
                        {formData.typeLot === 'Express' && (
                            <input
                                type="text"
                                placeholder="Premio Base"
                                className="cajatexto"
                                id="premioBase"
                                name="premioBase"
                                required
                                onChange={handleChangeNumer}
                            />
                        )}
                        <label>Subir Imagen de fondo:</label>
                        <input
                            type="file"
                            onChange={handleFileChange}
                            className="input-file"
                        />
                        <button className="btnform button-modern">Crear Sorteo</button>
                        {espera && (
                            <h1 className="espera">Creando Sorteo, espera un momento por favor</h1>
                        )}
                    </form>
                </div>
            )}

            <div className="dashadminsorteos">
                <div className="sorteoDinero">
                    
                    <h1 onClick={()=>toggleVisibility('Dinero')} className={`toggle-title ${isVisibleDinero ? 'open' : ''}`}>
                        sorteos de dinero {contDinero}
                    </h1>

                    {isVisibleDinero && (
                        <div>
                            {dataSorteo.map(sorteo => {
                                if (sorteo.typeLot === 'Dinero' && sorteo.estado !== 'archivado') {
                                    return <Sorteo data={sorteo} key={sorteo.id} socket={socket} board={board}/>;
                                }
                            })}
                        </div>
                    )}
                </div>
                <div className="sorteoProducto">
                    <h1 onClick={()=>toggleVisibility('Producto')} className={`toggle-title ${isVisibleProducto ? 'open' : ''}`}>
                        sorteos de Productos {contProducto}
                    </h1>

                    {isVisibleProducto && (
                        <div>
                            {dataSorteo.map(sorteo => {
                                if (sorteo.typeLot === 'Producto' && sorteo.estado !== 'archivado') {
                                    return <Sorteo data={sorteo} key={sorteo.id} socket={socket} board={board} />;
                                }
                            })}
                        </div>
                    )}
                </div>
                <div className="sorteoExpress">
                    <h1 onClick={()=>toggleVisibility('Express')} className={`toggle-title ${isVisibleExpress ? 'open' : ''}`}>
                        sorteos Express {contExpress}
                    </h1>

                    {isVisibleExpress && (
                        <div>
                            {dataSorteo.map(sorteo => {
                                if (sorteo.typeLot === 'Express' && sorteo.estado !== 'archivado') {
                                    return <Sorteo data={sorteo} key={sorteo.id} socket={socket} board={board} />;
                                }
                            })}
                        </div>
                    )}
                </div>
                <div className="sorteoArchivado">
                    <h1 onClick={()=>toggleVisibility('archivado')} className={`toggle-title ${isVisibleArchivado ? 'open' : ''}`}>
                        sorteos Archivados {contArchivado}
                    </h1>

                    {isVisibleArchivado && (
                        <div>
                            {dataSorteo.map(sorteo => {
                                if (sorteo.estado === 'archivado') {
                                    return <Sorteo data={sorteo} key={sorteo.id} socket={socket} />;
                                }
                            })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Sorteos;
